export function exportDesignPng(svgEl, contentEl) {
  return new Promise((resolve) => {
    if (!svgEl || !contentEl || !contentEl.childNodes.length) return resolve("");
    const box = contentEl.getBBox();
    if (!box.width || !box.height) return resolve("");
    const pad = 30;
    const vb = [box.x - pad, box.y - pad, box.width + pad * 2, box.height + pad * 2];
    const clone = svgEl.cloneNode(true);
    clone.querySelectorAll("[data-export-hide]").forEach((n) => n.remove());
    clone.setAttribute("viewBox", vb.join(" "));
    clone.setAttribute("width", vb[2]);
    clone.setAttribute("height", vb[3]);
    clone.setAttribute("xmlns", "http://www.w3.org/2000/svg");
    const xml = new XMLSerializer().serializeToString(clone);
    const img = new Image();
    img.onload = () => {
      const k = 2;
      const canvas = document.createElement("canvas");
      canvas.width = vb[2] * k;
      canvas.height = vb[3] * k;
      const ctx = canvas.getContext("2d");
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      resolve(canvas.toDataURL("image/png"));
    };
    img.onerror = () => resolve("");
    img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(xml);
  });
}
